<div class="flex flex-col gap-8">
  <h2 class="font-bold text-lg text-light-300">Join Seedio</h2>

  <form
    [formGroup]="form"
    class="flex flex-col"
    autocomplete="off"
    (ngSubmit)="onSubmit()"
  >
    <div class="flex flex-col items-start gap-8 overflow-hidden w-full">
      <div class="flex flex-col gap-1 w-full">
        <label class="font-medium text-base text-light-200" for="fullName">
          Full Name
          <span class="text-red-100">*</span>
        </label>

        <input
          id="fullName"
          pInputText
          formControlName="fullName"
          type="text"
          pSize="large"
          class="w-full p-inputtext"
          name="fullName"
          autocomplete="off"
          [style]="{
            'ng-invalid ng-dirty':
              f['fullName'].invalid && f['fullName'].touched
          }"
        />
      </div>

      <div class="flex flex-col gap-1 w-full">
        <label class="font-medium text-base text-light-200" for="email">
          Email
          <span class="text-red-100">*</span>
        </label>

        <input
          id="email"
          pInputText
          formControlName="email"
          type="text"
          pSize="large"
          placeholder="mail@mail.com"
          class="w-full p-inputtext"
          name="email"
          autocomplete="off"
          [style]="{
            'ng-invalid ng-dirty': f['email'].invalid && f['email'].touched
          }"
        />
      </div>

      <div class="flex flex-col gap-1 w-full">
        <label class="font-medium text-base text-light-200" for="mobile">
          Mobile Number
          <span class="text-red-100">*</span>
        </label>

        <div class="flex flex-row gap-1 w-full">
          <input
            id="countryCode"
            pInputText
            formControlName="countryCode"
            type="text"
            pSize="large"
            placeholder="+30"
            class="w-[70px] p-inputtext"
            name="countryCode"
            autocomplete="off"
            [style]="{
              'ng-invalid ng-dirty':
                f['countryCode'].invalid && f['countryCode'].touched
            }"
          />

          <input
            id="mobile"
            pInputText
            formControlName="mobile"
            type="number"
            pSize="large"
            placeholder="6991234567"
            class="no-spinner w-[calc(100%-74px)] p-inputtext"
            name="mobile"
            autocomplete="off"
            [style]="{
              'ng-invalid ng-dirty': f['mobile'].invalid && f['mobile'].touched
            }"
          />
        </div>
      </div>

      <div class="flex flex-col gap-1 w-full">
        <label class="font-medium text-base text-light-200" for="password">
          Password
          <span class="text-red-100">*</span>
        </label>

        <p-password
          id="password"
          formControlName="password"
          type="password"
          pSize="large"
          placeholder="**********"
          [toggleMask]="true"
          name="password"
          [feedback]="false"
          styleClass="w-full"
          class="w-full"
          inputStyleClass="w-full !py-2.5 !pl-3.5"
          autocomplete="off"
          [style]="{
            'ng-invalid ng-dirty':
              f['password'].invalid && f['password'].touched
          }"
        />
        <p
          class="text-xs"
          [ngClass]="{
            'text-red-100': f['password'].invalid && f['password'].touched,
            'text-light-100': f['password'].valid && f['password'].touched
          }"
        >
          Minimum length: 8 characters
        </p>
      </div>

      <p-fluid>
        <p-button
          type="submit"
          label="Let's go!"
          size="large"
          styleClass="w-full"
          [disabled]="!form.valid"
          [fluid]="true"
        />
      </p-fluid>

      <p class="font-semibold text-base text-light-300">
        Already a member?
        <a class="font-normal text-blue-100 hover:underline ms-2" href="/login">
          Sign in
        </a>
      </p>
    </div>
  </form>
</div>
